import { UserStatusTypes } from "types"

export const normalizeMerchantStatus = (status: unknown): UserStatusTypes => {
  if (typeof status !== "string") return UserStatusTypes.NEW

  const normalizedStatus = status.trim().toUpperCase()
  if (normalizedStatus === UserStatusTypes.ACTIVE) return UserStatusTypes.ACTIVE
  if (normalizedStatus === UserStatusTypes.NEW) return UserStatusTypes.NEW
  if (normalizedStatus === UserStatusTypes.COMMON) return UserStatusTypes.COMMON
  if (
    normalizedStatus === UserStatusTypes.DISABLED ||
    normalizedStatus === "BLOCKED" ||
    normalizedStatus === "SUSPENDED" ||
    normalizedStatus === "PAUSED" ||
    normalizedStatus === "UNINSTALLED" ||
    normalizedStatus === "UNSUBSCRIBE"
  )
    return UserStatusTypes.DISABLED

  return UserStatusTypes.NEW
}
